import React from "react";

import StepHeader from "./StepHeader";

import { batterySwapSteps } from "../constants";
import ArrowIcon from "../../../../Common/Svgs/ArrowIcon";
import WeightDeliveredIcon from "../../../../Common/Svgs/WeightDeliveredIcon";
import WeightCollectedIcon from "../../../../Common/Svgs/WeightCollectedIcon";

export const AssignmentCard = ({
  title,
  description,
  icon,
  bgClass,
  textClass,
  subTextClass,
  arrowClass,
  onClick,
}) => (
  <div
    onClick={onClick}
    className={`
      h-[196px]
      rounded-xl
      p-4
      cursor-pointer
      flex
      gap-8
      ${bgClass}
    `}
  >
    <div className="flex flex-col justify-center w-full">
      {icon}

      <div className="flex justify-between w-full items-end">
        <div>
          <p
            className={`font-poppins font-medium text-sm leading-none mt-2 ${textClass}`}
          >
            {title}
          </p>

          <p
            className={`font-aileron font-normal text-xs mt-1 ${subTextClass}`}
          >
            {description}
          </p>
        </div>

        <ArrowIcon className={`${arrowClass} rotate-90`} size={20} />
      </div>
    </div>
  </div>
);

const AssignmentTypeSelector = ({ updateStep }) => {
  return (
    <div>
      <StepHeader
        title="Select battery swap type"
        onBack={() => updateStep(batterySwapSteps.REQUEST_CREATED)}
      />

      <div className="space-y-4">
        <AssignmentCard
          title="Deliver via Agent"
          description="Select to deliver new batteries to the driver"
          icon={<WeightDeliveredIcon className="text-white" />}
          bgClass="bg-[linear-gradient(112.74deg,_#1A7075_0%,_#045358_100%)]"
          textClass="text-white"
          subTextClass="text-[#E7E7E7]"
          arrowClass="text-white"
          onClick={() => updateStep(batterySwapSteps.SELECT_AGENT)}
        />

        <AssignmentCard
          title="Pickup at Hub Station"
          description="Select to allow the driver to pickup batteries from a hub station"
          icon={<WeightCollectedIcon className="text-black" />}
          bgClass="bg-[linear-gradient(112.44deg,_#FFDD72_2.37%,_#FFD553_98.43%)]"
          textClass="text-black"
          subTextClass="text-[#6F6F6F]"
          arrowClass="text-[#6F6F6F]"
          onClick={() => updateStep(batterySwapSteps.SELECT_HUB)}
        />
      </div>
    </div>
  );
};

export default AssignmentTypeSelector;
